import { gql } from "@apollo/client";

export const AUTH_URL_AWS = gql`
    query AuthUrl_AWS {
        authUrl_aws
    }
`